import { render, staticRenderFns } from "./CreatePin.vue?vue&type=template&id=1b01d711&scoped=true"
import script from "./CreatePin.vue?vue&type=script&lang=js"
export * from "./CreatePin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b01d711",
  null
  
)

export default component.exports